import React from 'react';
import Checkbox from 'rc-checkbox';
import DateTime from 'react-datetime';
import { PropTypes } from 'prop-types';
import { parse as parseUrl } from 'query-string';
import { ApiCollection, StatePicker } from '@td/practice_management_js';

class SearchFilters extends React.Component {
  constructor(props) {
    super(props);

    this.onStateChange             = this.onStateChange.bind(this);
    this.onSetServiceSpecialty     = this.onSetServiceSpecialty.bind(this);
    this.onSetActiveFilter         = this.onSetActiveFilter.bind(this);
    this.onSetNeedsProvidersFilter = this.onSetNeedsProvidersFilter.bind(this);
    this.onStartDateChange         = this.onStartDateChange.bind(this);
    this.clearStartDate            = this.clearStartDate.bind(this);
    this.search                    = this.search.bind(this);
    this.onSetProviderID           = this.onSetProviderID.bind(this);
    this.state = {};
  }

  componentDidMount(){
    const params = parseUrl(window.location.search);
    const { state_cd, provider_id } = params;
    this.setState({
      state_cd,
      provider_id
    }, () => this.search());
  }

  onStateChange(stateCode) {
    this.setState({ state_code: stateCode });
  }

  onSetServiceSpecialty(value) {
    this.setState({ service_specialty_code: value });
  }

  onStartDateChange(moment) {
    if (!moment) {
      return;
    }
    const dateString = moment.toISOString();
    this.setState({ start_date: dateString });
  }

  // checked is original checked state. (http://react-component.github.io/checkbox/)
  onSetActiveFilter(ev) {
    if (!ev) {
      return;
    }
    this.setState({ active: ev.target.checked });
  }

  // checked is original checked state. (http://react-component.github.io/checkbox/)
  onSetNeedsProvidersFilter(ev) {
    if (!ev) {
      return;
    }
    this.setState({ needs_providers: ev.target.checked });
  }

  onSetProviderID(ev){
    if (!ev) {
      return;
    }
    this.setState({ provider_id: ev.target.value })
  }

  search() {
    const filter = { ...this.state };
    if (filter.active) {
      filter.start_date = undefined;
    } else {
      // casts false into undefined
      filter.active = undefined;
      if(filter.start_date){
        filter.start_date = moment(filter.start_date).tz('America/Chicago', true).format("YYYY/MM/DD hh:mm:ss A z")
      }
    }
    if (!filter.needs_providers) {
      filter.needs_providers = undefined;
    }
    filter.page = 1;
    if (filter.state_code === '') {
      filter.state_code = undefined;
    }
    if (filter.provider_id === '') {
      filter.provider_id = undefined;
    }

    if (filter.service_specialty_code === ''){
      filter.service_specialty_code = undefined;
    }

    const { applySearchFilter } = this.context;
    applySearchFilter(filter);
  }

  dateTimeValue() {
    if (!this.state.start_date) {
      return this.state.start_date;
    } else {
      return undefined;
    }
  }

  clearStartDate() {
    this.refs.dateTimePicker.setState({ inputValue: '', selectedDate: undefined }, () => {
      this.setState({ start_date: undefined });
    });
  }

  render() {
    const { search } = this;
    const { provider_id } = this.state;
    return (
      <div className="search-filter">
        <h2>Filters</h2>
        <div className="filter">
          <label>
            Location:<br />
            <StatePicker defaultState={this.state.state_code} onSelect={ (ev, value) => this.onStateChange(value)} />
          </label>
        </div>
        <div className="filter">
          <ApiCollection endpoint='/v4/ref_service_specialty/consult_service_offering' ref="serviceSpecialtyCode">
            { (specialities) => {
              return (
                <div className='filter'>
                  <label htmlFor="serviceSpeciality" style={{display: 'block'}}>
                    For service specialty
                  </label>
                  <select
                    name='serviceSpecialtyCode'
                    id='serviceSpecialtyCode'
                    ref="specialtySelect"
                    onChange={ (ev) => this.onSetServiceSpecialty(ev.target.value)}
                  >
                    <option value=''>Please select</option>
                    { specialities.ref_service_specialty.map ( specialty => (
                      <option
                        value={specialty.service_specialty_code}
                        key={specialty.service_specialty_code}
                      >
                        { specialty.service_specialty_name }
                      </option>
                    ))}
                  </select>
                </div>
              )
            }}
          </ApiCollection>
        </div>
        <div className="filter">
          <label>
            <Checkbox onChange={this.onSetActiveFilter} /> &nbsp; Active Only
          </label>
        </div>
        <div className="filter">
          <label>
            <Checkbox onChange={this.onSetNeedsProvidersFilter} /> &nbsp; Needs Providers
          </label>
        </div>
        <div className="filter">
          <label>
            Provider ID:<br/>
            <input type="text" onChange={this.onSetProviderID} value={provider_id}/>
          </label>
        </div>
        <div className="filter">
          <label>
            Starting after:
            <DateTime
              ref="dateTimePicker"
              onBlur={this.onStartDateChange}
              inputProps={{
                disabled: this.state.active
              }}
            />
          </label>
          <p>
            <span onClick={this.clearStartDate}>Clear</span>
          </p>
        </div>
        <hr style={{ width: '100%' }} />
        <div className="button" style={{ textAlign: 'center' }} onClick={search}>Search</div>
      </div>
    );
  }
}
SearchFilters.contextTypes = {
  applySearchFilter: PropTypes.func
};
export default SearchFilters;
